export default {
	tabs: {
		notDefined: 'Tanımlanmamış',
		journal: 'Yövmiye defteri',
		invoice: 'Fatura',
		reconciliation: 'Mutabakat',
		all: 'Tümü'
	}
}